import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/postHashtag/importer/postHashtagImporterActions'

export default importerReducers(actions)
